/**
 * FooterLinkColumn Molecule Component
 * Column of navigation links for footer
 */

import React from 'react';
import { storyblokEditable, StoryblokComponent } from '@/lib/blocks';
import { Heading } from '@/components/atoms/Heading';
import type { FooterLinkColumnBlok } from '@/types';

export interface FooterLinkColumnProps {
  blok: FooterLinkColumnBlok;
  className?: string;
}

export const FooterLinkColumn: React.FC<FooterLinkColumnProps> = ({ blok, className = '' }) => {
  const { title, links } = blok;

  return (
    <div {...storyblokEditable(blok)} className={`flex flex-col gap-4 ${className}`}>
      <Heading level="h4" className="text-sm font-bold uppercase text-gray-900">
        {title}
      </Heading>
      <ul className="flex flex-col gap-2">
        {links && links.map((link) => (
          <li key={link._uid}>
            <StoryblokComponent blok={link} />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FooterLinkColumn;
